import { render, staticRenderFns } from "./DepositApply.vue?vue&type=template&id=02722fd2"
import script from "./DepositApply.vue?vue&type=script&lang=js"
export * from "./DepositApply.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Theme1DesktopDepositPage: require('/app/components/Theme1/Desktop/DepositPage.vue').default})
